module.exports = __webpack_public_path__ + "static/media/engagement-this-that.dbfd42c6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/engagement-this-that.svg
// module id = 436
// module chunks = 0